// Marketing landing-page pricing. Mirrors the real plan tiers in
// hooks/useSubscription.ts (the checkout source of truth) so the landing and
// checkout never drift. Freemium (Sep 2026): the FREE tier (sign up, no card,
// 20 credits) is the front door; paid plans are charged on day one — no trial.
export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    price: 19,
    period: 'month',
    description: 'For solo creators getting started',
    features: [
      '100 credits per month',
      '1 brand',
      'Regular quality',
      'Full template library',
      'Product, Model & Social posts + free-text',
      'Email support',
    ],
    cta: 'Start Free',
    highlighted: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 49,
    period: 'month',
    description: 'For serious content creators',
    features: [
      '300 credits per month',
      'Everything in Starter',
      '3 brands',
      'Enhanced & Studio quality',
      'Carousel posts',
      'Ad Strategist + Ad Pilot',
      'Priority generation queue',
    ],
    cta: 'Start Free',
    highlighted: true,
  },
  {
    id: 'business',
    name: 'Business',
    price: 129,
    period: 'month',
    description: 'For agencies and teams',
    features: [
      '1,000 credits per month',
      'Everything in Pro',
      '10 brands',
      'More Ad Strategist analyses + Ad Pilot campaigns',
      'Team seats (coming soon)',
      'Priority support',
    ],
    cta: 'Start Free',
    highlighted: false,
  },
];
